import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  IconButton,
  Button,
  Grid,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EditIcon from "@mui/icons-material/Edit";

function ViewRoleModal({ open, handleClose, selectedRole, handleOpenEditModal }) {
  if (!selectedRole) return null;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ pb: 1, pt: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">View Role</Typography>
          <Box>
            <Button 
              variant="outlined" 
              startIcon={<EditIcon />} 
              onClick={() => {
                handleClose();
                handleOpenEditModal(selectedRole);
              }}
              sx={{ mr: 1 }}
            >
              Edit
            </Button>
            <IconButton onClick={handleClose} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>
      
      <DialogContent 
        sx={{ 
          pt: 2, 
          maxHeight: '500px',
          overflowY: 'auto'
        }}
      >
        <Box sx={{ mb: 3 }}>
          <Typography 
            variant="body2" 
            color="text.secondary" 
            sx={{ mb: 1, fontWeight: 500 }}
          >
            Role Name:
          </Typography>
          <TextField
            fullWidth
            value={selectedRole.name || ""}
            variant="outlined"
            InputProps={{
              readOnly: true,
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'rgba(0, 0, 0, 0.02)',
                '& fieldset': {
                  borderColor: 'rgba(0, 0, 0, 0.12)',
                },
              },
            }}
          />
        </Box>
        
        <Box sx={{ mb: 3 }}>
          <Typography 
            variant="body2" 
            color="text.secondary" 
            sx={{ mb: 1, fontWeight: 500 }}
          >
            Description:
          </Typography>
          <TextField
            fullWidth
            value={selectedRole.description || "No description provided"}
            variant="outlined"
            multiline
            rows={4}
            InputProps={{
              readOnly: true,
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'rgba(0, 0, 0, 0.02)',
                '& fieldset': {
                  borderColor: 'rgba(0, 0, 0, 0.12)',
                },
                '& textarea': {
                  color: selectedRole.description ? 'text.primary' : 'text.secondary',
                  fontStyle: selectedRole.description ? 'normal' : 'italic',
                },
              },
            }}
          />
        </Box>
        
        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          Assigned Permissions
        </Typography>
        
        <Grid container spacing={2}>
          {selectedRole.permissions && selectedRole.permissions.length > 0 ? (
            selectedRole.permissions.map((permission, index) => (
              <Grid item xs={12} md={6} key={index}>
                <Box display="flex" alignItems="center">
                  <CheckCircleIcon color="success" sx={{ mr: 1 }} />
                  <Typography variant="body2" color="text.primary">
                    {permission}
                  </Typography>
                </Box>
              </Grid>
            ))
          ) : (
            <Grid item xs={12}>
              <Typography variant="body2" color="text.secondary" sx={{ pl: 1 }}>
                No permissions assigned to this role.
              </Typography>
            </Grid>
          )}
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default ViewRoleModal; 